import { Checkbox, Divider, FormControl, FormControlLabel, Stack, Typography } from '@mui/material';
import { type Control, type Condition, ConditionOperatorEnum } from '@repo/api-gw-sdk';
import { Fragment } from 'react';
import { Loader } from '@/components/shared/loader';
import { useDAL } from '@/contexts/useDAL';
import { ControlsSeverity } from '@/data/inventory/data';
import { isValueCondition } from '@/types/advanceFilter';
import { ControlIndicator, controlKeysPriorities } from './controlIndicator';
import { CONTROL_ID_PROPERTY, CONTROL_LEVEL_PROPERTY, MUTED_CONTROL_ID_PROPERTY } from '../queryBuilder/propertyNames';
export const ControlsListFilter = ({
  priority,
  onChange,
  conditions
}: {
  priority: string;
  conditions: Condition[];
  onChange: (conditions: Condition[]) => void;
}) => {
  const dal = useDAL();
  const {
    data: body
  } = dal.controls.useList();
  if (!body?.controls.length) {
    return <Loader />;
  }
  const groupedControls = body?.controls.reduce<Record<string, Control[]>>((acc, control) => {
    const priority_0 = control.severity.toLowerCase();
    acc[priority_0] = acc[priority_0] || [];
    acc[priority_0].push(control);
    return acc;
  }, {}) || {};
  const priorities = priority === 'muted' ? controlKeysPriorities.filter(x => x !== 'muted') : [priority];
  const condition = conditions.find(x_0 => isValueCondition(x_0) && (x_0.property === CONTROL_ID_PROPERTY || x_0.property === MUTED_CONTROL_ID_PROPERTY));
  const selectedResources = isValueCondition(condition) && condition?.value || [];
  return <FormControl variant='outlined' fullWidth className='px-[24px]'>
      {priorities.map(p => {
      return <Stack key={p} className='mb-[12px]'>
            {priority === 'muted' && <Typography variant='subtitle1' className='uppercase mb-[12px]'>
                {`${p}-severity controls`}
              </Typography>}
            {groupedControls[p]?.sort((a, b) => a.name?.localeCompare(b.name)).map(({
          id,
          name
        }, index) => {
          return <Fragment key={id}>
                    <FormControlLabel data-testid={`filter-control-${id}`} className='w-full flex items-start' control={<Stack direction='row' sx={{
              alignItems: 'center'
            }}>
                          <Checkbox className='p-[8px]' size='small' checked={selectedResources.includes(id)} onChange={(event, value) => {
                const values = value ? [...selectedResources, id] : selectedResources.filter(x_1 => x_1 !== id);
                onChange(conditions.filter(x_2 => isValueCondition(x_2) && x_2.property !== CONTROL_LEVEL_PROPERTY && x_2.property !== CONTROL_ID_PROPERTY && x_2.property !== MUTED_CONTROL_ID_PROPERTY).concat(values.length ? [{
                  property: priority === 'muted' ? MUTED_CONTROL_ID_PROPERTY : CONTROL_ID_PROPERTY,
                  operator: ConditionOperatorEnum.ContainsAnyOf,
                  value: values
                }] : []));
              }} />
                          <ControlIndicator backgroundColor={ControlsSeverity[priority === 'muted' ? 'muted' : p].color} />
                        </Stack>} label={<Typography className='ml-[12px] mt-[12px]'>
                          {name}
                        </Typography>} />
                    {index !== groupedControls[p].length - 1 && <Divider sx={{
              margin: '12px -24px'
            }} />}
                  </Fragment>;
        })}
          </Stack>;
    })}
    </FormControl>;
};